<body>
  <div class="container-fluid">
    <div class="row">
      <div class="col-9 justify-content-evenly cardmain  ">
        <div class="row">
          <div class="col-4">
            <div class="card" style="width: 100%">
              <div class="card-body">
                <div class="card1">
                  <span class="card-title">Total Users</span>
                  <span><img src="/assets/dashboardIcon/TotalUsers.svg" /></span>
                </div>

                <h2 class="number"><b>{{dashboardData.totalUsers}} </b></h2>

                <p class="graphtext-color">
                  <img    *ngIf="dashboardData.usersmonthlyGrowthRate!>0"   src="/assets/dashboardIcon/GreenUpIcon.svg" /> 
                  <img   *ngIf="dashboardData.usersmonthlyGrowthRate!<0" src="/assets/dashboardIcon/RedDown.svg" />
                  <span *ngIf="dashboardData.usersmonthlyGrowthRate!<0" class="green-text" style="color: red;">{{dashboardData.usersmonthlyGrowthRate}}%</span>
                  <span  *ngIf="dashboardData.usersmonthlyGrowthRate!>0" class="green-text" style="color:#17B26A;">{{dashboardData.usersmonthlyGrowthRate}}%</span>
                  <span  *ngIf="dashboardData.usersmonthlyGrowthRate!=0" class="gray-text" style="margin-left: 5px;">than last month</span>
                </p>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="card" style="width: 100%">
              <div class="card-body">
                <div class="card1">
                  <span class="card-title">Tourists</span>
                  <span>
                    <img src="/assets/dashboardIcon/BlackTourist.svg" />
                  </span>
                </div>

                <h2 class="number"><b>{{dashboardData.touristCount}} </b></h2>

                <p class="graphtext-color">
                  <img  *ngIf="dashboardData.touristmonthlyGrowthRate!>0" src="/assets/dashboardIcon/GreenUpIcon.svg" />
                     <img   *ngIf="dashboardData.touristmonthlyGrowthRate!<0" src="/assets/dashboardIcon/RedDown.svg" />
                  <span *ngIf="dashboardData.touristmonthlyGrowthRate!<0" class="green-text" style="color: red;">{{dashboardData.touristmonthlyGrowthRate}}%</span>
                    <span  *ngIf="dashboardData.touristmonthlyGrowthRate!>0" class="green-text" style="color:#17B26A;">{{dashboardData.touristmonthlyGrowthRate}}%</span>
                  <span *ngIf="dashboardData.touristmonthlyGrowthRate!=0" class="gray-text" style="margin-left: 5px;">than last month</span>
                </p>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="card" style="width: 100%">
              <div class="card-body">
                <div class="card1">
                  <span class="card-title">Tour Guides</span>
                      <span><img src="/assets/dashboardIcon/TotalUsers.svg" /></span>
                </div>

                <h2 class="number"><b>{{dashboardData.tourGuideCount}} </b></h2>

                <p class="graphtext-color">
                  <img   *ngIf="dashboardData.guidemonthlyGrowthRate!>0" src="/assets/dashboardIcon/GreenUpIcon.svg" />
        <img *ngIf="dashboardData.guidemonthlyGrowthRate!<0" src="/assets/dashboardIcon/RedDown.svg" />

                  <span *ngIf="dashboardData.guidemonthlyGrowthRate!<0" class="green-text" style="color: red;">{{dashboardData.guidemonthlyGrowthRate}}%</span>
                  <span   *ngIf="dashboardData.guidemonthlyGrowthRate!>0" class="green-text" style="color:#17B26A;">{{dashboardData.guidemonthlyGrowthRate}}%</span>
                  <span class="gray-text" style="margin-left: 5px;">than last month</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="card" style="width: 100%">
              <div class="card-body">
                <div class="card1">
                  <span class="card-title">Active Bookings</span>
                  <span><img src="/assets/dashboardIcon/blackCalender.svg" /></span>
                </div>

                <h2 class="number"><b>{{bookingrdData.totalActiveBookings}} </b></h2>

                <p class="graphtext-color">
                  <img *ngIf="bookingrdData.monthlyBookingGrowthRate!>0" src="/assets/dashboardIcon/GreenUpIcon.svg" />
                   <img *ngIf="bookingrdData.monthlyBookingGrowthRate!<0" src="/assets/dashboardIcon/RedDown.svg" />
                  <span *ngIf="bookingrdData.monthlyBookingGrowthRate!>0" class="green-text" style="color:#17B26A;">{{bookingrdData.monthlyBookingGrowthRate}}%</span>
                     <span *ngIf="bookingrdData.monthlyBookingGrowthRate!<0" class="green-text" style="color: red;">{{bookingrdData.monthlyBookingGrowthRate}}%</span>
                  <span class="gray-text" style="margin-left: 5px;">than last month</span>
                </p>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="card" style="width: 100%">
              <div class="card-body" >
                <div class="card1">
                  <span class="card-title">Monthly Revenue</span>
                  <span><img src="/assets/dashboardIcon/dollar.svg" /></span>
                </div>

                <h2 class="number"><b> {{totalRevenue}}$ </b></h2>

                 <p class="graphtext-color">
                  <img *ngIf="growthRate!>0" src="/assets/dashboardIcon/GreenUpIcon.svg" />
                   <img *ngIf="growthRate!<0" src="/assets/dashboardIcon/RedDown.svg" />
                  <span *ngIf="growthRate!>0" class="green-text" style="color:#17B26A;">{{growthRate}}%</span>
                     <span *ngIf="growthRate!<0" class="green-text" style="color: red;">{{growthRate}}%</span>
                       <span *ngIf="growthRate==0" class="green-text" style="color: rgb(5, 179, 248);">{{growthRate}}%</span>
                  <span class="gray-text"  style="margin-left: 5px;">than last month</span>
                </p>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="card" style="width: 100%"> 
              <div class="card-body" >
                <div class="card1">
                  <span class="card-title">Pending Approvals</span>
                  <span><img src="/assets/dashboardIcon/pendingI.svg" /></span>
                </div>

                <h2 class="number"><b>{{dashboardData.totalPendingRequests}}</b></h2>

           <p class="graphtext-color">
                  <img *ngIf="dashboardData.pendingRequestsGrowthRate!>0" src="/assets/dashboardIcon/GreenUpIcon.svg" />
                   <img *ngIf="dashboardData.pendingRequestsGrowthRate!<0" src="/assets/dashboardIcon/RedDown.svg" />
                  <span *ngIf="dashboardData.pendingRequestsGrowthRate!>0" class="green-text" style="color:#17B26A;">{{dashboardData.pendingRequestsGrowthRate}}%</span>
                     <span *ngIf="dashboardData.pendingRequestsGrowthRate!<0" class="green-text" style="color: red;">{{dashboardData.pendingRequestsGrowthRate}}%</span>
                       <span *ngIf="dashboardData.pendingRequestsGrowthRate==0" class="green-text" style="color: rgb(5, 179, 248);">{{dashboardData.pendingRequestsGrowthRate}}%</span>
                  <span class="gray-text"  style="margin-left: 5px;">than last month</span>
                </p>
              </div>
            </div>
          </div>
        </div>

       <div class="row">

  <div class="col-6">
    <div class="card small-card">
      <div class="card-body" id="pending">
        <div class="card-title-wrapper"><span>Revenue Overview</span> <span>| Total: {{totalRevenue}}$ </span> </div>
        <canvas #barChartCanvas class="small-canvas" style="width: 100%;"></canvas>
      </div>
    </div>
  </div>

 
  <div class="col-6">
    <div class="card small-card">
      <div class="card-body">
        <div class="card-title-wrapper">
          <span>Booking Overview </span></div>
        <canvas #bookingChartCanvas class="small-canvas" style="width: 100%;"></canvas>
      </div>
    </div>
  </div>
</div>


      </div>






      
      <div class="col-2 recentactivities">
        <div class="row">
          <ul class="list-group list-group-flush" style="border-radius: 16px;"> 
              <span class="CommingSoon"> Coming Soon </span>
            <p style="margin-left: 10px;"> <span style="font-weight: 700;"> Recent Activities </span></p>
          
            <li class="list-group-item">
              <img
                class="rounded-circle"
                width="40"
                height="40"
                src=" /assets/dashboardIcon/simg.jpg"
              />
           <span class="notifications-item"> New guide application </span>  
              <small class="Time-span">Just now</small>
            </li>
            <li class="list-group-item">
              <img src="/assets/dashboardIcon/Avatar.png" /> <span class="notifications-item"> Application
              received </span> <small class="Time-span">59 minutes ago</small>
            </li>
            <li class="list-group-item">
              <img src="/assets/dashboardIcon/Avatar.png" /> <span class="notifications-item">Trip booked </span>
              <small class="Time-span">5 hours ago</small>
            </li>
            <li class="list-group-item">
              <img src="/assets/dashboardIcon/Avatar.png" /><span class="notifications-item"> New user  registration</span>
              
              <small class="Time-span">11 hours ago</small>
            </li>
            <li class="list-group-item">
              <img src="/assets/dashboardIcon/Avatar.png" /> <span class="notifications-item"> Trip cancelled </span> 
              <small class="Time-span">Today, 09:49 AM</small>
            </li>
            <li class="list-group-item">
              <img src="/assets/dashboardIcon/Avatar.png" /> <span class="notifications-item"> Payment processed </span> 
              <small class="Time-span">Today, 10:15 AM</small>
            </li>
            <li class="list-group-item">
              <img src="/assets/dashboardIcon/Avatar.png" /><span class="notifications-item">  Feedback submitted</span>
              <small class="Time-span">Today, 10:30 AM</small>
            </li>
            <li class="list-group-item">
              <img src="/assets/dashboardIcon/Avatar.png" /> <span class="notifications-item"> Schedule updated</span>
              <small class="Time-span">Today, 01:00 PM</small>
            </li>
            <li class="list-group-item">
              <img src="/assets/dashboardIcon/Avatar.png" /> <span class="notifications-item"> Refund processed </span>
              <small class="Time-span">Today, 02:00 PM</small>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</body>
